/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_Exporterror1Inputs */

const en_common_error_exporterror1 = /** @type {(inputs: Common_Error_Exporterror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Error`)
};

/**
* | output |
* | --- |
* | "Export Error" |
*
* @param {Common_Error_Exporterror1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_error_exporterror1 = /** @type {((inputs?: Common_Error_Exporterror1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_Exporterror1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_error_exporterror1(inputs)
});
export { common_error_exporterror1 as "common_error_exportError" }